(() => {
  angular
    .module('finance')
    .controller('curlecPayoutNewPayoutModal', CurlecPayoutNewPayoutModal);

  CurlecPayoutNewPayoutModal.$inject = [
    '$uibModalInstance',
    'abp.services.finance.curlecPayout',
  ];

  function CurlecPayoutNewPayoutModal($uibModalInstance, curlecPayoutSvc) {
    const vm = this;

    vm.loading = 0;
    vm.pageState = 0;
    vm.result = null;
    vm.parameters = {
      amount: 0,
      accountNumber: '',
      bankCode: '',
      details: '',
      recipientRef: '',
      internalRef: '',
      customerUID: '',
    };

    vm.createNewPayout = createNewPayout;
    vm.back = back;
    vm.close = close;
    init();

    function init() {}

    function createNewPayout() {
      let input = $.extend({}, vm.parameters);

      vm.pageState = 1;

      vm.loading += 1;
      curlecPayoutSvc
        .createNewPayout(input)
        .success((data) => {          
          vm.result = JSON.stringify(data.response, null, 2);
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function back() {
      vm.pageState = 0;
      vm.result = null;
    }

    function close() {
      $uibModalInstance.dismiss();
    }
  }
})();
